import { fetchEventsV2, fetchEvents } from '@/api/basecamp.api';
import type { EventExpandOpts, IFetchEventV2Query, IFetchEventParams, IPaginationFields } from '@condo/domain';
import { useInfiniteQuery, useQuery } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useEvents = (queryOrRef: MaybeRef<IFetchEventParams>, expand?: EventExpandOpts, pagination?: IPaginationFields) => {
    const query = computed(() => unref(queryOrRef));
    return useQuery(['events', query], () => fetchEvents(query.value, expand, pagination), { initialData: { data: [] } });
};

export const useEventV2InfiniteQuery = (filterQuery: MaybeRef<Omit<IFetchEventV2Query, 'pagination'>>) => {
    const pageSize = 20;

    const infiniteQuery = useInfiniteQuery({
        queryKey: computed(() => ['mfh-events', unref(filterQuery)]),
        queryFn: async ({ pageParam = 1 }) => {
            const pagination = { page: pageParam, size: pageSize };
            const { data, pagination: pag } = await fetchEventsV2({ ...unref(filterQuery), pagination });
            return {
                data,
                nextPage: pag?.hasNextPage ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage: { nextPage: number | undefined }) => lastPage.nextPage,
    });

    return {
        ...infiniteQuery,
        allData: computed(() => infiniteQuery.data.value?.pages.flatMap((page: { data: any[] }) => page.data) ?? []),
    };
};
